import { translate } from '@/i18n';

import { CostPolicyType } from './types';

/** A project policy with "Account for available credit" off: it counts the
 * full cost, and no credit lowers it. Organization policies have no such
 * setting, so only an explicit false counts. */
export const ignoresCredit = (policy: { use_credit?: boolean }) =>
  policy.use_credit === false;

export const getCostPolicyActionOptions = (
  type: CostPolicyType = 'project',
  isResourceScoped = false,
) =>
  [
    // Blocking new resource creation is a project-wide action and is not
    // available when the policy is narrowed to a single resource.
    !isResourceScoped && {
      value: 'block_creation_of_new_resources',
      label: translate('Block creation of new resources'),
    },
    {
      value: 'block_modification_of_existing_resources',
      label: translate('Block modification of existing resources'),
    },
    {
      value: 'notify_organization_owners',
      label: translate('Notify organization owners'),
    },
    type === 'project' && {
      value: 'notify_project_team',
      label: translate('Notify project team'),
    },
    {
      value: 'terminate_resources',
      label: translate('Schedule termination of existing resources'),
    },
    {
      value: 'request_downscaling',
      label: translate('Request downscaling of resources'),
    },
    {
      value: 'request_pausing',
      label: translate('Request pausing of resources'),
    },
    {
      value: 'restrict_members',
      label: translate(
        'Request restriction of project member access to resources',
      ),
    },
    {
      value: 'notify_external_user',
      label: translate('Notify external user'),
    },
  ].filter(Boolean);

export const policyPeriodOptions = {
  total: { value: 1, label: translate('Total') },
  oneMonth: { value: 2, label: translate('{count} month', { count: 1 }) },
  threeMonth: { value: 3, label: translate('{count} month', { count: 3 }) },
  twelveMonth: { value: 4, label: translate('{count} month', { count: 12 }) },
};
